import { useEffect } from 'react';
import { Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { useGetExpectedCommissions } from 'lendingApi/lendingApiHooks';
import styles from '../../SummaryCard.module.css';

export type TInitialCommission = {
  amount: number;
  rate: number;
  repeat_rate: number;
} | null;

type TProps = {
  applicationId: string;
  offerId?: string;
  isLoadingPayments: boolean;
  offerIsSelected: boolean;
  offerNotSelected: boolean;
  setInitialCommission: (initialCommission: TInitialCommission) => void;
};

export const InitialCommission = ({
  applicationId,
  offerId,
  isLoadingPayments,
  offerIsSelected,
  offerNotSelected,
  setInitialCommission,
}: TProps) => {
  const { introducerId } = useIntroducerData();
  const { formatCurrency, formatPercentage } = useNumberFormat();

  const { data: expectedCommission, isFetching } = useGetExpectedCommissions(
    introducerId,
    applicationId,
    offerId,
  );

  useEffect(() => {
    setInitialCommission(expectedCommission?.data || null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expectedCommission]);

  const formatCommission = () => {
    if (!expectedCommission?.data) {
      return '-';
    }

    const { amount, rate } = expectedCommission.data;
    return (
      <p
        className={clsx(styles.value, styles.expectedCommissionValueContainer, {
          [styles.selectedValue]: offerIsSelected,
          [styles.unselectedValue]: offerNotSelected,
        })}
      >
        <span>{formatPercentage(rate)}</span>
        <span>{`(${formatCurrency(amount)})`}</span>
      </p>
    );
  };

  return (
    <>
      {isLoadingPayments || isFetching ? (
        <div className={styles.loaderContainer}>
          <Spinner />
        </div>
      ) : (
        formatCommission()
      )}
    </>
  );
};
